import React, { useState } from 'react';
import { Badge } from 'components/shadcn/ui/badge';
import { HGTable } from 'components/HGTable';
import { devicesUpgradeStatusColumn } from './logDetailsTableColumns';
import { useConfigStatuses } from './service';

const StatusTable = () => {
    const {
        data: configStatuses,
        isLoading,
        upgradeRecord,
    } = useConfigStatuses();
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);

    return (
        <>
            <div className="px-5 pt-5">
                <h4 className="text-lg font-semibold">
                    Upgrade Status
                    <Badge
                        color={
                            upgradeRecord?.state === 'Complete'
                                ? 'success'
                                : upgradeRecord?.state === 'Failed'
                                  ? 'error'
                                  : 'info'
                        }
                        className="ml-1"
                    >
                        {upgradeRecord?.state}
                    </Badge>
                </h4>
                {upgradeRecord?.firmwarePackageName && (
                    <h6>{`Firmware Package: ${upgradeRecord?.firmwarePackageName}`}</h6>
                )}
                <h6>{`Update ID: ${upgradeRecord?.UpdateID}`}</h6>
            </div>
            <HGTable
                columns={devicesUpgradeStatusColumn}
                data={configStatuses ?? []}
                loading={isLoading}
                sortField={sortField}
                setSortField={setSortField}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                currentPage={1}
                setCurrentPage={() => {}}
                pageSize={configStatuses?.length ?? 0}
                totalItems={configStatuses?.length ?? 0}
            />
        </>
    );
};

export default StatusTable;
